import { render, staticRenderFns } from "./newsearchOrderListCopy.vue?vue&type=template&id=0ead8b28&scoped=true&"
import script from "./newsearchOrderListCopy.vue?vue&type=script&lang=js&"
export * from "./newsearchOrderListCopy.vue?vue&type=script&lang=js&"
import style0 from "./newsearchOrderListCopy.vue?vue&type=style&index=0&id=0ead8b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead8b28",
  null
  
)

export default component.exports